export const otbLabelInner = {
    ' > span': {
        color: '$loginInfoIcon',
        lineHeight: 0,
    },
    'alignItems': 'center',
    'display': 'flex',
    'gap': '5px',
}

export const tooltipText = {fontSize: '$loginTooltipText'}

export const ssoError = {
    alignItems: 'center',
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    width: '100%',
}

export const ssoErrorInner = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    width: '100%',
}

export const logoWrapper = {textAlign: 'center'}

export const buttonWrapper = {marginTop: '10px'}
